import React from 'react';
import { FEE_NOT_ALLOWED_MESSAGE } from 'utils/constants';
import { Modal } from 'components/Modal';

const getModalContent = () => `<p>${FEE_NOT_ALLOWED_MESSAGE}</p>`;

const HasFeeModal = ({ cost, onClose, onConfirmation, ...props }) => {
  return (
    <Modal
      title="Warning"
      content={getModalContent()}
      maxWidth="md"
      onConfirmation={onClose}
      onDismiss={onClose}
      {...props}
    />
  );
};

export { HasFeeModal };
